import { createRoot } from "react-dom/client";
import App from "./App";
import { Toaster } from "react-hot-toast";
import "./index.css";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary.js";
import store from "./store/store";
import { Provider } from "react-redux";
import "react-tooltip/dist/react-tooltip.css";

const rootElement = document.getElementById("root") as HTMLElement;
createRoot(rootElement).render(
  <ErrorBoundary>
    <Toaster
      position="top-right"
      reverseOrder={false}
      containerStyle={{ zIndex: 99999 }}
      toastOptions={{
        style: {
          fontSize: "14px",
        },
      }}
    />
    <Provider store={store}>
      <App />
    </Provider>
  </ErrorBoundary>
);
